
import { supabase } from "@/integrations/supabase/client";

export const getApiKey = async (keyName: string): Promise<string> => {
  const { data, error } = await supabase.functions.invoke('get-secret', {
    body: { name: keyName }
  });
  
  if (error) {
    console.error(`Error fetching ${keyName}:`, error);
    throw new Error(`Failed to fetch ${keyName}`);
  }
  
  return data.openai_key;
};

export const makeAIApiCall = async (ticker: string, aiProvider: string) => {
  const { data, error } = await supabase.functions.invoke('search-company-kpis', {
    body: {
      ticker
    }
  });

  if (error) {
    console.error('Error calling search-company-kpis:', error);
    throw new Error(`AI API error: ${error.message}`);
  }

  return data.choices[0].message.content;
};
